import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import router from '@/router';
import Axios, { AxiosResponse } from 'axios';
import Vue from 'vue';
import { postAsync } from '@/rpcutil';
import { RpcEvent } from '@/events';


class RpcException {
  method: string = "";
  endpoint: string = "";
  data?: any;
  response?: AxiosResponse<any>;

  constructor(obj: Partial<RpcException>) {
    Object.assign(this, obj);
  }
}

async function get(endpoint: string) : Promise<any> {
  const result = await Axios.get(endpoint);

  if(result.status != 200) {
    throw new RpcException({
      method: "GET",
      endpoint,
      response: result,
    });
  }

  return result.data;
}

async function post(endpoint: string, data: any) : Promise<any> {
  const result = await Axios.post(endpoint, data);

  if(result.status != 200) {
    throw new RpcException({
      method: "POST",
      endpoint,
      response: result,
    });
  }

  return result.data;
}

/* event emitting */
const callbacks: { [key: string]: ((...args: any) => any)[] } = {};

@Module({ name: 'master', namespaced: true, dynamic: true, store: store })
class MasterStore extends VuexModule {
  loggedIn: boolean = false;

  @Mutation
  setLoggedIn( val: boolean ) {
    this.loggedIn = val;
  }

  @Action({ rawError: true })
  async isAuthorized() {
    // キャッシュ済みならそれを返す
    if(this.loggedIn)
      return true;
    else {
      // ログインチェック
      const result = await get("/api/check");
      // 必要に応じてキャッシュ
      if(result.result == "yes") {
        this.setLoggedIn(true);
        return true;
      }
      else
        return false;
    }
  }

  @Action({ rawError: true })
  async execAuthentication({ user, password }: { user: string, password: string }) {
    // ログイン実行
    const result = await post('/api/login', {
      user,
      password
    });

    // リダイレクト
    if(result.result == "ok") {
      this.setLoggedIn(true);
      return true;
    }
    else
      return false;
  }

  @Action({ rawError: true })
  async execDeauthentication() {
    // ログアウト実行
    const result = await get('/api/logout');
    
    if(result.result == "ok") {
      this.setLoggedIn(false);
      return true;
    }
    else
      return false;
  }

  @Action({ rawError: true })
  async execGETAsync(endpoint: string) : Promise<any> {
      const result = await get(endpoint);

      if(result.result == "ok")
          return result.data;
      else if(result.result == "error")
          throw new Error(`RPC Error [${endpoint}]: ${result.error}`);
      throw new Error(`RPC Error [${endpoint}]: Unkown result "${result.result}"`);
  }

  @Action({ rawError: true })
  async uploadAsset(file: File): Promise<string> {
        let formData = new FormData();
        formData.append('image', file);

        const result =  (await postAsync('/api/assets', formData)).data;
        if(!result.path) {
            RpcEvent.emit('error', `'path' field is empty`);
            throw new Error(`'path' field is empty`)
        }
        return result.path;
  }


  emit(name: string, ...args: any) {
      if(callbacks[name] !== undefined) {
          for(const f of callbacks[name])
              f(...args);
      }
  }

  // Notice: Each event can have only one handler.
  //         Repeated registration will override the exisiting handler.
  on(name: string, callback: (...args: any) => any): () => void {
      if(callbacks[name] !== undefined) {
          callbacks[name] = callbacks[name].concat([callback]);
      }
      else {
          callbacks[name] =  [callback];
      }

      return () => { callbacks[name] = callbacks[name].filter(f => f !== callback) };
  }
}

export default getModule(MasterStore);
